import React from 'react'
import './style.scss'

const Footer = () => {
    return (
        <footer className="login-page__footer footer">
            <div className="footer__top">
                <div className="footer__contact">
                    <span className="footer__contact-title">
                        Wydawnictwo Pedagogiczne Operon:
                    </span>
                    <a href="mailto: info@operon.pl" className="footer__contact-email">info@operon.pl</a>
                    <a href="tel: 58 679 00 00" className="footer__contact-phone">tel. 58 679 00 00</a>
                </div>
                <ul className="footer__menu">
                    <li className="footer__menu-item">
                        <a href="https://operon.pl/Strefa-nauczyciela" className="footer__menu-link" target="_blank" rel="noopener noreferrer">Strefa nauczyciela Operon</a>
                    </li>
                    <li className="footer__menu-item">
                        <a href="http://multiteka.operon.pl/" className="footer__menu-link" target="_blank" rel="noopener noreferrer">Multiteka</a>
                    </li>
                    <li className="footer__menu-item">
                        <a href="https://deklaracje.operon.pl/" className="footer__menu-link" target="_blank" rel="noopener noreferrer">Deklaracje</a>
                    </li>
                    <li className="footer__menu-item">
                        <a href="https://egzaminy.operon.pl/" className="footer__menu-link" target="_blank" rel="noopener noreferrer">Egzaminy</a>
                    </li>
                    <li className="footer__menu-item">
                        <a href="http://zamowienia.operon.pl/" className="footer__menu-link" target="_blank" rel="noopener noreferrer">Dotacje</a>
                    </li>
                    <li className="footer__menu-item">
                        <a href="http://oswiataiprawo.pl/" className="footer__menu-link" target="_blank" rel="noopener noreferrer">Oświata i Prawo</a>
                    </li>
                    <li className="footer__menu-item">
                        <a href="https://konto.operon.pl/regulamin" className="footer__menu-link" target="_blank" rel="noopener noreferrer">Regulamin</a>
                    </li>
                </ul>
            </div>
            <div className="footer__bottom">
                <p className="footer__copyrights">&copy; Wydawnictwo Operon 2019</p>
            </div>
        </footer>
    )
}

export default Footer
